import { createContext, useContext } from 'react';

export interface CampaignDisplayCampaign {
	id: string;
	texts: {
		name?: string;
		corporateTitle?: string;
		resumeShort?: string;
		objectives?: string;
		resume?: string;
		activities?: string;
		benefits?: string;
		updateAndLinks?: string;
	};
	media?: { location: string; width: number; height: number };
	carouselImages?: { type: string; location: string; width: number; height: number; alt?: string }[];
	heroVideoUrl?: string;
	heroImageAlt?: string;
	finished: boolean;
	textsNotFound: boolean;
	categories: number[];
	cityName?: string;
	startDate?: string;
	endDate?: string;
	beneficiaries: { direct: number; indirect: number };
	sdgs?: number[];
	ngos: {
		id: string;
		name?: string;
		logo?: { location: string; width: number; height: number };
		accreditedByLealtad?: boolean;
	}[];
}

export interface CampaignDisplayMetadata {
	color: string;
	showCampaignCategory: boolean;
	showCampaignCity: boolean;
	showCampaignDates: boolean;
	hideStatsOnActiveCampaigns: boolean;
	hideCollected: boolean;
}

export interface CampaignDisplayAggregates {
	donors: number;
	collected: number;
	funding?: number;
	progress: number;
	finished: boolean;
}

export interface CampaignDisplayData {
	campaign: CampaignDisplayCampaign;
	metadata: CampaignDisplayMetadata;
	locale: string;
	aggregates?: CampaignDisplayAggregates;
	onDonate?: () => void;
}

const CampaignDisplayContext = createContext<CampaignDisplayData | null>(null);

export function CampaignDisplayProvider({ data, children }: { data: CampaignDisplayData; children: React.ReactNode }) {
	return <CampaignDisplayContext.Provider value={data}>{children}</CampaignDisplayContext.Provider>;
}

export function useCampaignDisplayContext() {
	return useContext(CampaignDisplayContext);
}
